import { CourseListFilters } from "../generated/graphql"
import { buildFilterStorageKey, FILTER_STATE_STORAGE_KEY_PREFIX } from "./filterPersistence"
import { safeSessionStorage } from "./safeStorage"

/**
 * Per-Embed gescopte Persistenz des zuletzt angesehenen Kurses über
 * sessionStorage. Wird beim Öffnen der Kursdetails gemerkt und beim Zurück zur
 * Liste gelesen, um den Eltern-Viewport an den zuletzt angesehenen Kurs zu
 * scrollen und ihn kurz hervorzuheben.
 *
 * Der Storage-Key teilt sich denselben deterministischen Seed-Hash wie die
 * Filter-Persistenz (gleiches Embed-Scoping), nutzt aber einen eigenen Prefix,
 * damit Kurs- und Filterzustand getrennt bleiben.
 */

export const LAST_VIEWED_COURSE_STORAGE_KEY_PREFIX = "koLastViewedCourse:"

/**
 * Baut einen deterministischen, pro Seed stabilen Storage-Key. Der Hash-Suffix
 * wird aus buildFilterStorageKey wiederverwendet (identisches Seed-Scoping),
 * nur der Prefix unterscheidet sich.
 */
export function buildLastViewedCourseKey(seed: CourseListFilters | undefined): string {
    const filterKey = buildFilterStorageKey(seed)
    // Hash-Suffix aus dem Filter-Key extrahieren (alles nach dem Filter-Prefix).
    const hashSuffix = filterKey.startsWith(FILTER_STATE_STORAGE_KEY_PREFIX)
        ? filterKey.slice(FILTER_STATE_STORAGE_KEY_PREFIX.length)
        : filterKey
    return LAST_VIEWED_COURSE_STORAGE_KEY_PREFIX + hashSuffix
}

/**
 * Merkt die zuletzt angesehene courseId. Wirft niemals.
 */
export function persistLastViewedCourse(key: string, courseId: string): void {
    try {
        safeSessionStorage.setItem(key, courseId)
    } catch {
        // Storage blockiert/instabil — still degradieren
    }
}

/**
 * Lädt die zuletzt angesehene courseId oder null. Wirft niemals.
 */
export function loadLastViewedCourse(key: string): string | null {
    try {
        return safeSessionStorage.getItem(key)
    } catch {
        return null
    }
}

/**
 * Entfernt den persistierten Kurs für den gegebenen Key. Wirft niemals.
 */
export function clearLastViewedCourse(key: string): void {
    try {
        safeSessionStorage.removeItem(key)
    } catch {
        // Storage blockiert/instabil — still degradieren
    }
}
